import React from 'react';
import moment from "moment";
import { Icon } from '@material-ui/core';

import './PostsWidget.scss';

function PostsWidget({ Adventure, messages }) {

  if (!messages || !messages.length || !Adventure) return <div />;

  return (
    <div className="posts-widget">
      <h1>Mensagens da {Adventure.company}</h1>
      <ul>
        {messages.map((message) => (
          <li key={message.pk_request_message}>
            <div>
              <div className="company-logo">
                  <img src={Adventure.company_logo} alt=""/>
              </div>
              <div className="post-text-header-small">
                <strong>{Adventure.company}</strong>
                <span>{moment(message.created_at).format("DD/MM/YYYY HH:mm")}</span>
              </div>
            </div>
            <div className="post-text">
              <div className="post-text-header">
                <strong>{Adventure.company}</strong>
                <span>{moment(message.created_at).format("DD/MM/YYYY HH:mm")}</span>
              </div>
              <div className="post-text-message">
                <p>
                  <Icon className="fa fa-quote-left" style={{ left: '-25px' }} />
                  {message.description}
                  <Icon className="fa fa-quote-right" style={{ marginLeft: '7px',  bottom: '-2px'}} />
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PostsWidget;